import React from 'react'

const NotFoundPage = () => {
  return <div>ERROR 404</div>
}

export default NotFoundPage
